module.exports = __webpack_public_path__ + "static/media/Logo_Lac-Superieur.f8fa113f.jpg";